type ZoneName = { name: string }

function isZoneForRecordName(zoneName: string, recordName: string): boolean {
    return recordName === zoneName || recordName.endsWith(`.${zoneName}`)
}

export function selectZoneForRecordName<T extends ZoneName>(zones: T[], name: string): T | null {
    const recordName = name.toLowerCase()
    const candidates = zones.filter((zone) => isZoneForRecordName(zone.name.toLowerCase(), recordName))
    const [longest] = candidates.sort((a, b) => b.name.length - a.name.length)

    return longest ?? null
}
